<div class="container contact-nieuwsbrief-sections">
  <div class="contact">
    <wv-contact></wv-contact>
  </div>
  <div class="nieuwsbrief">
    <wv-nieuwsbrief></wv-nieuwsbrief>
  </div>
</div>
